import { Disclosure, DisclosurePanel, Transition } from '@headlessui/react';
import clsx from 'clsx';

import { useSearchBoxContext } from '@/utils/hooks/context/searchBox/useSearchBoxContext';

import type { GroupsFormattedType } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/GroupsTab';
import { GroupItem } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/GroupsTab/GroupItem';
import { SocialProfileItem } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/ProfilesTab/SearchItems';

export function SearchGroupsItems() {
    const { dataContext } = useSearchBoxContext<GroupsFormattedType>();
    const { filteredData } = dataContext;
    return filteredData.map((group) => {
        return (
            <Disclosure key={group.id}>
                {({ open }) => (
                    <div
                        className={clsx({
                            'border-b border-icoGray-300 pb-2 last:border-0 dark:border-icoDarkMode-wolf':
                                true
                        })}>
                        <GroupItem open={open} group={group} />
                        <Transition
                            show={open}
                            enter="transition-all duration-300 ease-out"
                            enterFrom="transform grid-rows-[0fr]"
                            enterTo="transform grid-rows-[1fr]"
                            leave="transition-all duration-300 ease-out"
                            leaveFrom="transform grid-rows-[1fr]"
                            leaveTo="transform grid-rows-[0fr]">
                            <div className="grid">
                                <DisclosurePanel className="overflow-hidden">
                                    <div className="pt-3" />
                                    <div className="flex flex-col gap-2 border-l border-icoGray-300 pl-3 dark:border-icoDarkMode-beton">
                                        {group.social_profiles.map((profile) => (
                                            <SocialProfileItem key={profile.id} profile={profile} />
                                        ))}
                                    </div>
                                    <div className="pb-1" />
                                </DisclosurePanel>
                            </div>
                        </Transition>
                    </div>
                )}
            </Disclosure>
        );
    });
}
